import React, { useMemo } from 'react';
import { useRouter } from 'next/router';

import { Icon } from 'components';
import { ButtonV3 } from 'components/ComponentV2';
import { ActionMenuButton } from 'components/ActionMenuButton/ActionMenuButton.component';
import { useSponsorshipPlans } from 'pages/sponsorships/useSponsorshipPlans';
import { PAGE_ROUTES } from 'lib/page-routes';
import { useSponsorCompanies } from 'lib/providers/SocietySponsorshipProvider';

import styles from './Header.module.scss';

interface HeaderProps {
  onAddSponsors: () => void;
  goToPlans: () => void;
  copyOffersLink: () => void;
  copyInvitationLink: () => void;
}

export const Header: React.FC<HeaderProps> = (props: HeaderProps) => {
  const { copyOffersLink, onAddSponsors, goToPlans, copyInvitationLink } =
    props;
  const router = useRouter();
  const { sponsorshipPlans } = useSponsorshipPlans();
  const { sponsorCompanyIds } = useSponsorCompanies();

  const shareActionOptions = useMemo(
    () => [
      {
        id: '1',
        label: 'Copy link to Plans page',
        onClick: copyOffersLink,
      },
      {
        id: '2',
        label: 'Copy sponsor invitation link',
        onClick: copyInvitationLink,
      },
    ],
    [copyOffersLink, copyInvitationLink]
  );

  const navigateToDashboard = () => {
    router.push(PAGE_ROUTES.DASHBOARD);
  };

  return (
    <div className={styles.SponsorshipsHeader}>
      <div
        className={styles.SponsorshipsHeaderBreadcrumb}
        onClick={navigateToDashboard}
      >
        <Icon size="large" iconName="chevron-left" />
        <p>Dashboard</p>
      </div>
      <div className={styles.SponsorshipsHeaderContent}>
        <div>
          <p className={styles.title}>Sponsorships</p>
          <p className={styles.companyCount}>
            {sponsorCompanyIds.length} companies
          </p>
        </div>
        <div className={styles.SponsorshipsHeaderContentAction}>
          <ActionMenuButton
            buttonText="Share link"
            buttonStartIcon="icon_link"
            buttonColor="secondary"
            options={shareActionOptions}
          />
          <ButtonV3
            color={sponsorshipPlans?.length ? 'secondary' : 'primary'}
            startIcon={!sponsorshipPlans?.length ? 'icon_gear' : undefined}
            onClick={goToPlans}
            isLoading={!sponsorshipPlans}
          >
            {sponsorshipPlans?.length ? 'Plans' : 'Set up plans'}
          </ButtonV3>
          <ButtonV3
            isLoading={!sponsorshipPlans}
            color={sponsorshipPlans?.length ? 'primary' : 'secondary'}
            onClick={onAddSponsors}
          >
            Add sponsors
          </ButtonV3>
        </div>
      </div>
    </div>
  );
};
